.popoverListItem {
  min-width: 170px;
  padding: var(--ism-spacing-xs) var(--ism-spacing-s);
  cursor: pointer;
  outline: none;

  &[data-hovered] {
    background-color: var(--ism-color-surface-variant);
  }

  &[data-selected="true"] {
    background-color: var(--ism-color-surface-variant);
  }

  &[data-focus-visible] {
    background-color: var(--ism-color-surface-variant);
    outline: auto;
  }
}

.listboxSection {
  &:not(:last-child) {
    padding-bottom: var(--ism-spacing-xs);
    margin-bottom: var(--ism-spacing-xs);
    border-bottom: 1px solid var(--ism-color-outline-variant);
  }

  [dir="rtl"] & {
    direction: rtl;
  }

  @media (--ism-breakpoint-md) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
}

.listboxSectionHeader {
  grid-column: 1 / -1;
  padding: var(--ism-spacing-2xs) var(--ism-spacing-xs);
  margin-bottom: var(--ism-spacing-2xs);
  font-family: var(--ism-typeface-bold);
  font-weight: 400;
}

.playerFilterListItem {
  position: relative;
  display: flex;
  gap: var(--ism-spacing-2xs);
  align-items: center;
  text-wrap: nowrap;
}

.teamBadgeContainer {
  display: inline-block;
  width: 2.4rem;
  height: 2.4rem;
}
